module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activeScan) ? _c('div', {
    staticClass: "scan",
    on: {
      "click": _vm.emit
    }
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("./scan.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("打开微信用力扫我")]), _vm._v(" "), _c('p', [_vm._v("扫码是请注意手机与屏幕的距离，未成年用户请在家长陪同下操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a616c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iScan/iScan.vue
// module id = 775
// module chunks = 10